export default __webpack_public_path__ + "static/media/28.1cc401d7.jpg";